'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_querystring-es3@0.2.1@querystring-es3/index.js
// module id = 47
// module chunks = 0